module.exports = __webpack_public_path__ + "img/1715650204837-WhatsApp Image 2024-05-14 at 09.14.43.jpeg.c352babe.webp";